import { React } from "react";
const TennisScoreBoard = ({eventDetails,scoreboardData}) => { 

    //let data = scoreboardData;
     
    let scoreData = "";
    //let currentSet = data[0].currentSet;
    let current_set = 0;
    let homeName = "";
    let awayName = "";

    if(scoreboardData!==null && scoreboardData!==undefined) {
        let data = scoreboardData;
        scoreData = data[0].score;
        current_set = data[0].currentSet;

        homeName = (scoreData.home.name);
        awayName = (scoreData.away.name);  
    }

    const getSetData = (currentSet,scoreData) => { 
        if(scoreData!=="" && scoreData!==undefined) {
           
        return (
          <tr>
           
            
            {/*for (let x = 0; x < currentSet; x++) 
            {
                let lastSet = parseInt(currentSet) - 1;
                if (x == lastSet) {
                    <td class="runner-score colwidthset active ">{scoreData.home.games}</td>
                } else {
                   <td class="runner-score colwidthset">{scoreData.home.gameSequence[x]}</td>
                } 
            }*/}

            <td class="runner-score active col-divider colwidthset">{scoreData.home.score}</td>
            <td class="runner-score col-divider colwidthset">{scoreData.home.serviceBreaks}</td>
            </tr> 
        )
    }
      };

    return(
         <div>
            <style>
                {
                    `.scores {
                        background-color: #2b2f35;
                        border: 1px solid #2b2f35;
                        padding: 0.25rem;
                    }
                    .scores .runnername {
                        margin-top: 7px;
                        line-height: 0.2;
                        color: white;
                        font-size: 18px;
                    }
                    .scores .runner-score {
                        color: white;
                        font-size: 18px;
                        margin-top: 2px;
                        padding: 0px;
                    }
                    .colwidthset {
                        width: 1vw;
                    }
                    .scores .active {
                        color: #009069;
                    }
                    .scores .col-divider {
                        border-left: 1px solid white;
                    }
                    .tablefotercs {
                        font-size: 12px;
                        color: white;
                    }
                    @media screen and (max-width: 767px) {
                        .scores .runnername {
                            margin-top: 7px;
                            line-height: 0.2;
                            color: white;
                            font-size: 12px;
                        }
                        .sethourshow {
                            line-height: 0.3;
                            font-size: 15px;
                        }
                        .tableresp {
                            display: inline-table;
                        }
                        .colwidthset {
                            width: 50px;
                        }
                        .tablefotercs {
                            font-size: 11px;
                            color: white;
                        }
                    }
                
                    /* soccer */
                    .timelineNS {
                        background: #303030;
                        height: 32px;
                        position: relative;
                    }
                
                    .timelineNS .half {
                        height: 6px;
                        float: left;
                        box-sizing: border-box;
                        position: relative;
                        margin-top: 13px;
                        margin-bottom: 13px;
                        width: 50%;
                    }
                
                    .timelineNS .firstHalf {
                        margin-left: -4px;
                    }
                
                    .timelineNS .empty-bar {
                        background: linear-gradient(0deg, #9c9c9c, #fff);
                        height: 5px;
                        position: absolute;
                        left: 6px;
                        right: 6px;
                    }
                
                    .timelineNS .empty-bar .bar {
                        background: linear-gradient(0deg, #087d0e, #0c0);
                        height: 5px;
                        max-width: 100%;
                    }
                
                    .timelineNS .tooltipNS {
                        position: absolute;
                        z-index: 1;
                    }
                
                    .timelineNS .top {
                        top: -18px;
                    }
                
                    .timelineNS .secondHalf {
                        margin-left: 4px;
                    }
                
                    .fa-basketball-ball {
                        color: #fff;
                    }
                
                    .timelineNS .tooltiptextNS {
                        display: none;
                        width: 100px;
                        background-color: #f8f8ff;
                        color: #000;
                        text-align: center;
                        border-radius: 6px;
                        height: auto;
                        border: 1px solid #000;
                    }
                
                    .timelineNS .toptt {
                        margin-top: -60px;
                    }
                
                    .timelineNS .tooltiptextNS p {
                        margin-bottom: 0;
                        font-size: small;
                    }
                
                    .timeshow {
                        color: white;
                        font-size: 18px;
                    }
                `
                }
            </style>
        <div className="scores" >
        <div className="row" style={{margin:"0px",padding: "2px"}}>
            <div className="col-4" style={{lineHeight:"0",padding: "0px"}}>
                <p className="runnername"><b id="homeName">{homeName}</b></p>
                <p className="runnername"><b id="awayName">{awayName}</b></p>
                <span style={{lineHeight:"0.4",color:"rgb(0, 177, 129)"}}>
                Set <span id="current_set">{current_set}</span> |
                </span> <span className="sethourshow" style={{color: "rgb(0, 177, 129)"}} id="gameTimeVal">0:0</span>
            </div>
            <div className="col-8" style={{textAlign:"center",lineHeight:"1", padding: "0px"}}>
                <table className="col-12 table-responsive-sm tableresp">
                    
                        <tbody id="tennisScoreCard">
                        <tr>
                            <td className="runner-score colwidthset ">0</td>
                            <td className="runner-score  colwidthset ">0</td>
                            <td className="runner-score active col-divider colwidthset" >0</td>
                             
                            <td className="runner-score col-divider colwidthset" >0</td>
                        </tr>
                        <tr>
                            <td className="runner-score colwidthset ">0</td>
                            <td className="runner-score  colwidthset ">0</td>
                            <td className="runner-score active col-divider colwidthset" >0</td>
                            
                            <td className="runner-score col-divider colwidthset"  >0</td>
                        </tr>
                        <tr className="col-12 tablefotercs">
                            <td className="colwidthset">1</td>
                            <td className="colwidthset">2</td>
                            
                            <td className="col-divider colwidthset">Points</td>
                            
                            <td className=" col-dividerlrhom col-divider colwidthset">ServBreak</td>
                        </tr> 
                        {getSetData(current_set,scoreData)}
                        </tbody>
                    
                </table>
            </div>
        </div>
        </div>
        </div>
    )
}

export default TennisScoreBoard;

{/*
let data = scoreBoard;
let scoreData = data[0].score;
let currentSet = data[0].currentSet;
//console.log(scoreData);
if (scoreData) {
    $('#current_set').html(currentSet);
    $('#homeName').html(scoreData.home.name);
    $('#awayName').html(scoreData.away.name);

let html = '<tr>';
for (let x = 0; x < currentSet; x++) {
let lastSet = parseInt(currentSet) - 1;
if (x == lastSet) {
    html += '<td class="runner-score colwidthset active ">' + scoreData.home.games + '</td>';
} else {
    html += '<td class="runner-score colwidthset ">' + scoreData.home.gameSequence[x] + '</td>';
}


}
html += '<td class="runner-score active col-divider colwidthset" >' + scoreData.home.score + '</td>';
html += '<td class="runner-score col-divider colwidthset" >' + scoreData.home.serviceBreaks + '</td>';
html += '</tr>';

html += '<tr>';
for (let x = 0; x < currentSet; x++) {
let lastSet = parseInt(currentSet) - 1;
    
    if (x == lastSet) {
        html += '<td class="runner-score colwidthset active ">' + scoreData.away.games + '</td>';
    } else {
        html += '<td class="runner-score colwidthset ">' + scoreData.away.gameSequence[x] + '</td>';
    }
}
html += '<td class="runner-score active col-divider colwidthset" >' + scoreData.away.score + '</td>';
html += '<td class="runner-score col-divider colwidthset" >' + scoreData.away.serviceBreaks + '</td>';
html += '</tr>';

html += '<tr class="col-12 tablefotercs">';
for (let x = 1; x <= currentSet; x++) {
    if (x == currentSet) {
        html += '<td class="colwidthset active">' + x + '</td>';
    } else {
        html += '<td class="colwidthset">' + x + '</td>';
    }

}
html += '<td class="col-divider colwidthset">Points</td>';
html += '<td class=" col-dividerlrhom col-divider colwidthset">ServBreak</td>';
html += '</tr>';

$('#tennisScoreCard').html(html)
*/}